import Hero from '../components/sections/Hero';
import AboutSection from '../components/sections/AboutSection';
import PressBar from '../components/sections/PressBar';
import EventsPreview from '../components/sections/EventsPreview';
import TikTokShelf from '../components/sections/TikTokShelf';
import CyberLunaWindow from '../components/base/CyberLunaWindow';
import Logo from '../components/base/Logo';
import XPButton from '../components/base/XPButton';
import Seo from '../components/base/Seo';
import styles from './Home.module.css';
import content from '../data/content.json';

const { home } = content;
const { address } = content.global;

const Home = () => {
  return (
    <>
      <Seo pageKey="home" />
      <Hero
        title={home.hero.title}
        subtitle={home.hero.subtitle}
        backgroundImage={`${process.env.PUBLIC_URL}/images/building.jpeg`}
        logo={<Logo size="lg" variant="black"/>}
        height="100vh"
        overlay={true}
      >
        <XPButton
          as="a"
          variant="primary"
          href="https://shotgun.live/en/venues/the-boombox-miami"
          target="_blank"
          rel="noopener noreferrer"
        >
          {home.hero.cta_button}
        </XPButton>
        <p className={styles.heroSupport}>
          {home.hero.support_text}
        </p>
      </Hero>

      <div data-section="events">
        <EventsPreview />
      </div>

      <PressBar />

      <AboutSection
        title={home.about.title}
        windowTitle="about_the_box.exe"
        content={
          <div>
            <p className={styles.aboutParagraphLede}>{home.about.paragraphs[0]}</p>
            <p className={styles.aboutParagraphSm}>{home.about.paragraphs[1]}</p>
            <p className={styles.aboutParagraphSm}>{home.about.paragraphs[2]}</p>
            <div className={styles.aboutStats}>
              {home.about.stats.map((stat, i) => (
                <div key={i} className={styles.aboutStatItem}>
                  <div className={styles.aboutStatNumber}>{stat.number}</div>
                  <div className={styles.aboutStatLabel}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        }
        image={`${process.env.PUBLIC_URL}/real_images/12.jpg`}
      />

      <div className={styles.locationSection}>
        <h2 className={styles.locationTitle}>{home.location.title}</h2>
        <p className={styles.locationSubtitle}>{home.location.subtitle}</p>
        <div className={styles.locationWindow}>
          <CyberLunaWindow isStatic title={home.location.window_title}>
            <iframe
              src={address.maps_embed_url}
              title={address.maps_iframe_title}
              className={styles.mapFrame}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </CyberLunaWindow>
        </div>
        <a
          href={address.maps_url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.locationAddress}
        >
          {address.line1}, {address.line2}
        </a>
      </div>

      <TikTokShelf />
    </>
  );
};

export default Home;
